import { useBankAccountByBookkeepingAccountId } from '@features/bankAccounts/hooks/useBankAccountByBookkeepingAccountId'

import { useSandboxModeContext } from '../contexts/sandboxModeContext'

export const useSandboxBankAccountByBookkeepingAccountId = (bookkeepingAccountId?: string) => {
  const sandbox = useSandboxModeContext()
  const result = useBankAccountByBookkeepingAccountId(bookkeepingAccountId, { enabled: !sandbox })
  const bankAccount = sandbox?.sandboxState.bankAccounts.find(
    (account) => account.bookkeepingAccountId === bookkeepingAccountId,
  )

  return sandbox
    ? {
        accountTotalBalance: bankAccount?.bookedBalance?.value ?? 0,
        balanceCurrency: bankAccount?.bookedBalance?.currency ?? '',
        ...bankAccount,
      }
    : result
}
